import { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { fetchRequest } from '../../../../../redux/actions/autoLombardActions';
import { returnKeys } from '../../../../../helpers/common';

export const useRequestData = (setTitlePage) => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { currentRequestInfo, loading, debtLoading } = useSelector(({ autolombard }) => autolombard.currentRequest);
  const { accessFeatures } = useSelector(({ user }) => user);
  const [requestDetails, setRequestDetails] = useState(null);
  const [comments, setComments] = useState({});

  const form = useForm({mode: "all"});
  const updateCommentInArray = (array, newItem) => {
    if (!array) return [newItem];
    return array.some(item => item.id === newItem.id)
        ? array.map(item => item.id === newItem.id ? newItem : item)
        : [...array, newItem];
  };

  const handleCommentChange = useCallback((field, item, fieldName) => {
    return (e) => {
      const value = e.target.value;
      const newComment = { id: item?.id, comment: value };

      setComments(prev => {
        if (fieldName === 'photos') {
          return {
            ...prev,
            vehiclePhotos: updateCommentInArray(prev.vehiclePhotos, newComment)
          };
        } else if (fieldName === 'files') {
          return {
            ...prev,
            registrationDocumentPhotos: updateCommentInArray(prev.registrationDocumentPhotos, newComment)
          };
        } else {
          return { ...prev, [`${field}Comment`]: value };
        }
      });
    };
  }, []);

  useEffect(() => {
    if (currentRequestInfo) {
      form.reset({
        photos: currentRequestInfo?.car_request?.vehiclePhotos.map(photo => (photo)),
        files: currentRequestInfo?.car_request?.registrationDocumentPhotos.map(file => (file)),
        ...currentRequestInfo,
      });
    }
  }, [currentRequestInfo]);

  useEffect(() => {
    if (id) {
      accessFeatures["title.header_section"] && setTitlePage(`Заявка № ${id}`);
      dispatch(fetchRequest(id));
    }
  }, [id, dispatch, setTitlePage, accessFeatures]);

  useEffect(() => {
    if (currentRequestInfo && returnKeys(currentRequestInfo).length) {
      setRequestDetails(currentRequestInfo);
    }
  }, [currentRequestInfo]);

  return {
    requestDetails,
    loading,
    debtLoading,
    form,
    comments,
    handleCommentChange,
    setRequestDetails,
  };
};